import React, { useState } from 'react';
import { Input } from 'antd';
import propTypes from 'prop-types';
import Button from '../button';
import IconSearch from '../../../assets/images/icons/icons-search1.svg';
import IconClose from '../../../assets/images/icons/icons-close.svg';
import './search.scss';

const SearchCenter = ({ onSearch, onClearSearch, placeholder = 'Search' }) => {
  const [searchValue, setSearchValue] = useState('');

  const isDiabled = () => searchValue === '';

  const clearSearch = () => {
    setSearchValue('');
    onClearSearch();
  };

  return (
    <div className="search-area">
      <Button type="ghost" onClick={() => onSearch(searchValue)} disabled={isDiabled()}>
        <img className="icon" alt="search icon" src={IconSearch} />
      </Button>
      <Input
        size="large"
        bordered={false}
        placeholder={placeholder}
        value={searchValue}
        onChange={(e) => setSearchValue(e.target.value)}
        onPressEnter={() => onSearch(searchValue)}
      />
      {searchValue && (
        <Button className="btn-transparent" onClick={clearSearch}>
          <img className="icon" alt="search icon" src={IconClose} />
        </Button>
      )}
    </div>
  );
};

SearchCenter.propTypes = {
  onSearch: propTypes.func,
  placeholder: propTypes.string,
};
export default SearchCenter;
